import React from 'react';

const BrandLogos = ({ brands }) => {
  return (
    <section className="section-padding-small brands-section">
      <div className="container">
        <p className="body-regular" style={{ textAlign: 'center', color: 'var(--text-secondary)', marginBottom: '48px' }}>
          Trusted by world-class organizations
        </p>
        <div className="brands-grid">
          {brands.map((brand, index) => (
            <div key={index} className="brand-logo">
              <span className="heading-3">{brand.logo}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BrandLogos;